module.exports = __webpack_public_path__ + "static/media/forby.88b5b032.m4a";